module.exports = __webpack_public_path__ + "static/home-hero-image@2x-e35e5ae1de0f2c38845e8f373928ad08.jpg";